import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import React from 'react';
import { decodeJWT } from './Components/jwtUtils';

//Auth
import useAuth from "./Auth/hook_useAuth";
import { setupInterceptors } from './Auth/Api';

//Context
import { AjustesProvider, useAjustes } from './Context/AjustesContext';

//Components
import LoadingScreen from './Components/LoadingScreen';

//Layout
import Layout from './Layout/Layout';

//Paginas
import Dashboard from './Pages/Dashboard';
import ListaAlunos from './Pages/ListaAlunos';
import MeusCursos from './Pages/MeusCursos';
import Calendario from './Pages/Calendario';
import Questionario from './Pages/Questionario';
import Modulos from './Pages/Modulos';
import Aulas from './Pages/Aulas';
import Aula from './Pages/Aula';
import Certificados from './Pages/Certificados';
import Biblioteca from './Pages/Biblioteca';
import Configuracoes from './Pages/Configuracoes';
import Chat from './Pages/Chat';
import Login from './Pages/Login';
import Provas from './Pages/Provas';
import SemPermissao from './Pages/SemPermissao';
import ListaUsuarios from './Pages/ListaUsuarios';
import Recuperar from './Pages/Recuperar';
import PrimeiroLogin from './Pages/PrimeiroLogin';
import Topicos from './Pages/Topicos';
import Empresas from './Pages/Empresas';
import Unidades from './Pages/Unidades';
import Cargos from './Pages/Cargos';
import TrocarSenha from './Pages/TrocarSenha';
import AulaGrupo from './Pages/AulaGrupo';
import RelatorioGrupo from './Pages/Relatorios/Grupo';
import RelatorioAcompanhamento from './Pages/Relatorios/Acompanhamento';
import RelatorioAluno from './Pages/Relatorios/Aluno';
import PesquisaSatisfacao from './Pages/PesquisaSatisfacao';
import RelatorioFeedback from './Pages/Relatorios/Feedback';
import RelatorioAvaliacaoEficacia from './Pages/Relatorios/AvaliacaoEficacia';
import RelatorioAvaliacaoReacao from './Pages/Relatorios/AvaliacaoReacao';
import RelatorioAvaliacaoReacaoHibrido from './Pages/Relatorios/AvaliacaoReacaoHibrido';
import Logs from './Pages/Relatorios/Logs';
import Ajustes from './Pages/Ajustes';

//Paginas Aluno
import DashboardAluno from './Pages/Aluno/DashboardAluno';
import Certificado from './Pages/Aluno/Certificado';
import HistoricoEscolar from './Pages/HistoricoEscolar';
import HistoricoEscolarAluno from './Pages/Aluno/HistoricoEscolarAluno';

//Paginas Gestor
import ListaUsuariosGestor from './Pages/Gestor/ListaUsuariosGestor';
import Resetar from './Pages/Resetar';

// Novo import para o componente QuestionarioReacao
import QuestionarioReacao from './Pages/QuestionarioReacao';
// Adicionar o componente de questionário de reação híbrido
import QuestionarioReacaoHibrido from './Pages/QuestionarioReacaoHibrido';
import QuestionarioEficacia from './Pages/QuestionarioEficacia';
import ValidarCertificado from './Pages/ValidarCertificado';

function MultiRoleRoute({ allowedRoles, children }) {
    const token = JSON.parse(localStorage.getItem("user_token"));
    const primeiro_login = localStorage.getItem("primeiro_login");
    const pesquisa_satisfacao = localStorage.getItem("pesquisa_satisfacao");
    const nivel = decodeJWT(token).nivel;
    const currentPath = window.location.pathname;
    const concluiu_aula = localStorage.getItem("concluiu_aula") === "true";
    
    // Verifica se está na rota correta para primeiro login
    if ((primeiro_login === '0' || primeiro_login === 'null') && currentPath !== '/primeiro-login') {
        window.location.href = '/primeiro-login';
        return null;
    }

    // Verifica se está na rota correta para trocar senha
    if (primeiro_login === '1' && currentPath !== '/trocar-senha') {
        window.location.href = '/trocar-senha';
        return null;
    }

    // Só verifica pesquisa de satisfação se não for Administrador e se já passou pelo primeiro login
    if (nivel !== 'Administrador' && primeiro_login === '2') {
        if (
            concluiu_aula === true && 
            (pesquisa_satisfacao === null || 
            pesquisa_satisfacao === 'null' || 
            pesquisa_satisfacao === undefined || 
            pesquisa_satisfacao === 'undefined' || 
            pesquisa_satisfacao === '')
        ) {
            if (currentPath !== '/pesquisa-satisfacao') {
                window.location.href = '/pesquisa-satisfacao';
                return null;
            }
        }
    }

    return allowedRoles.includes(nivel) ? children : <SemPermissao />;
}

function RouteChangeListener() {
    const location = useLocation();

    React.useEffect(() => {
        const lastAccess = localStorage.getItem('ultimo_acesso');
        const userToken = localStorage.getItem('user_token');
        const now = new Date().toISOString();

        if (lastAccess && userToken) {
            const lastAccessDate = new Date(lastAccess);
            const nowDate = new Date(now);
            const diffInSeconds = (nowDate - lastAccessDate) / 1000;

            if (diffInSeconds > process.env.REACT_APP_TOKEN_TEMPO_EXPIRACAO) {
                localStorage.clear();
                window.location.href = "/login";
            }
        }
        if (userToken) {
            localStorage.setItem('ultimo_acesso', now);
        }
    }, [location]);

    return null;
}

function AuthenticatedRoutes() {
    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    
    return (
        <Router>
            <RouteChangeListener />
            <Routes>
                <Route path="validar-certificado" element={<ValidarCertificado />} />
                <Route path="/" element={<Layout />}>
                    <Route index element={nivel === "Aluno" ? <DashboardAluno /> : <Dashboard />} />
                    <Route path="primeiro-login" element={<PrimeiroLogin />} />
                    <Route path="trocar-senha" element={<TrocarSenha />} />

                    <Route path="listar-alunos/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><ListaAlunos /></MultiRoleRoute>} />
                    <Route path="meus-cursos" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Gestor', 'Administrador', 'Moderador']}><MeusCursos /></MultiRoleRoute>} />
                    <Route path="calendario" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Calendario /></MultiRoleRoute>} />
                    <Route path="questionario/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Questionario /></MultiRoleRoute>} />
                    <Route path="questionario/p2/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Questionario /></MultiRoleRoute>} />
                    <Route path="questionario/curso/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Questionario /></MultiRoleRoute>} />
                    <Route path="questionario/extra/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Questionario /></MultiRoleRoute>} />
                    <Route path="questionario-reacao/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><QuestionarioReacao /></MultiRoleRoute>} />
                    <Route path="questionario/reacao/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><QuestionarioReacao /></MultiRoleRoute>} />
                    <Route path="questionario-reacao-hibrido/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><QuestionarioReacaoHibrido /></MultiRoleRoute>} />
                    <Route path="questionario/reacao-hibrido/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><QuestionarioReacaoHibrido /></MultiRoleRoute>} />
                    <Route path="avaliacao-eficacia/:id" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><QuestionarioEficacia /></MultiRoleRoute>} />
                    <Route path="modulos/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Modulos /></MultiRoleRoute>} />
                    <Route path="aulas/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Aulas /></MultiRoleRoute>} />
                    <Route path="aula/:id" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Aula /></MultiRoleRoute>} />
                    <Route path="configuracoes" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Configuracoes /></MultiRoleRoute>} />
                    <Route path="biblioteca" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Biblioteca /></MultiRoleRoute>} />
                    <Route path="provas-extras" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Provas /></MultiRoleRoute>} />
                    <Route path="chat" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><Chat /></MultiRoleRoute>} />
                    <Route path="pesquisa-satisfacao" element={<MultiRoleRoute allowedRoles={['Aluno', 'Gestor', 'Administrador', 'Moderador']}><PesquisaSatisfacao /></MultiRoleRoute>} />

                    {/* Rotas só de Admin */}
                    <Route path="listar-topicos" element={<MultiRoleRoute allowedRoles={['Administrador']}><Topicos /></MultiRoleRoute>} />
                    <Route path="relatorios/feedback" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador']}><RelatorioFeedback /></MultiRoleRoute>} />
                    <Route path="relatorios/avaliacao-reacao" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador']}><RelatorioAvaliacaoReacao /></MultiRoleRoute>} />
                    <Route path="relatorios/avaliacao-reacao-hibrido" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador']}><RelatorioAvaliacaoReacaoHibrido /></MultiRoleRoute>} />
                    <Route path="relatorios/avaliacao-eficacia" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador']}><RelatorioAvaliacaoEficacia /></MultiRoleRoute>} />
                    <Route path="relatorios/logs" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador', 'Gestor', 'Aluno']}><Logs /></MultiRoleRoute>} />
                    <Route path="ajustes" element={<MultiRoleRoute allowedRoles={['Administrador']}><Ajustes /></MultiRoleRoute>} />

                    {/* Rotas só de Aluno */}
                    <Route path="aluno/dashboard" element={<MultiRoleRoute allowedRoles={['Aluno']}><DashboardAluno /></MultiRoleRoute>} />
                    <Route path="aluno/certificado" element={<MultiRoleRoute allowedRoles={['Aluno']}><Certificado /></MultiRoleRoute>} />
                    <Route path="aluno/historico-escolar" element={<MultiRoleRoute allowedRoles={['Aluno']}><HistoricoEscolarAluno /></MultiRoleRoute>} />

                    {/* Rotas só de Gestor */}
                    <Route path="gestor/listar-usuarios" element={<MultiRoleRoute allowedRoles={['Gestor']}><ListaUsuariosGestor /></MultiRoleRoute>} />

                    {/* Rotas Gestor, Admin e Moderador */}
                    <Route path="listar-empresas" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador']}><Empresas /></MultiRoleRoute>} />
                    <Route path="listar-unidades" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador']}><Unidades /></MultiRoleRoute>} />
                    <Route path="listar-cargos" element={<MultiRoleRoute allowedRoles={['Administrador', 'Moderador']}><Cargos /></MultiRoleRoute>} />
                    <Route path="relatorios/acompanhamento" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><RelatorioAcompanhamento /></MultiRoleRoute>} />
                    <Route path="relatorios/grupo" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><RelatorioGrupo /></MultiRoleRoute>} />
                    <Route path="relatorios/aluno" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><RelatorioAluno /></MultiRoleRoute>} />
                    <Route path="aula-grupo/:id" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><AulaGrupo /></MultiRoleRoute>} />
                    <Route path="dashboard" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><Dashboard /></MultiRoleRoute>} />
                    <Route path="listar-usuarios" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><ListaUsuarios /></MultiRoleRoute>} />
                    <Route path="certificados" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><Certificados /></MultiRoleRoute>} />
                    <Route path="historico-escolar" element={<MultiRoleRoute allowedRoles={['Gestor', 'Administrador', 'Moderador']}><HistoricoEscolar /></MultiRoleRoute>} />
                </Route>
            </Routes>
        </Router>
    )
}

function NotAthenticatedRoutes() {
    return (
        <Router>
            <Routes>
                <Route path="*" element={<Login />} />
                <Route path="/recuperar" element={<Recuperar />} />
                <Route path="/resetar" element={<Resetar />} />
                <Route path="/validar-certificado" element={<ValidarCertificado />} />
            </Routes>
        </Router>
    )
}

function AppContent() {
    const { user, loading: authLoading } = useAuth();
    const { loading: ajustesLoading } = useAjustes();
    
    // Se estiver carregando autenticação ou ajustes, mostra a tela de loading
    if (authLoading || ajustesLoading) {
        return <LoadingScreen message="Carregando a plataforma..." />;
    }
    
    const user_token = localStorage.getItem("user_token");
    if (user_token === 'undefined') {
        localStorage.clear();
    }
    
    return user ? <AuthenticatedRoutes /> : <NotAthenticatedRoutes />;
}

function App() {
    React.useEffect(() => {
        setupInterceptors();
    }, []);

    return (
        <AjustesProvider>
            <AppContent />
        </AjustesProvider>
    );
}

export default App;
